import React, { useState } from "react";

import {
  Modal,
  Box,
  Typography,
  Autocomplete,
  Backdrop,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import CloseIcon from "@mui/icons-material/Close";
import { Btn } from "../../AbstractElements";

const ChangeWorkStatusModal = (props) => {
  const [status, setStatus] = useState(
    props.currentStatus ? props.currentStatus : ""
  );

  return (
    <div>
      <Dialog open={props.isOpen} onClose={props.handleClose}>
        <DialogTitle>Change Work Status</DialogTitle>
        <DialogContent>
          <Typography>
            Current Work Schedule is: {props.currentStatus}
          </Typography>
          <FormControl>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="FULL-TIME"
                control={
                  <Radio
                    onChange={(e, v) => {
                      console.log("!@#!@# ::: 111", e.target.value, v);
                      setStatus(e.target.value);
                    }}
                    checked={
                      status && status.trim() == "FULL-TIME" ? true : false
                    }
                  />
                }
                label="FULL-TIME"
              />
              <FormControlLabel
                value="INTERMITTENT"
                control={
                  <Radio
                    onChange={(e, v) => {
                      console.log("!@#!@# 222::: ", e.target.value, v);
                      setStatus(e.target.value);
                    }}
                    checked={
                      status && status.trim() == "INTERMITTENT" ? true : false
                    }
                  />
                }
                label="INTERMITTENT"
              />
              <FormControlLabel
                value="PART-TIME"
                control={
                  <Radio
                    onChange={(e, v) => {
                      console.log("!@#!@# 333::: ", e.target.value, v);
                      setStatus(e.target.value);
                    }}
                    checked={
                      status && status.trim() == "PART-TIME" ? true : false
                    }
                  />
                }
                label="PART-TIME"
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Btn
            attrBtn={{
              color: "primary",
              onClick: () => {
                props.values.worK_SCH = status;

                console.log("12345 ::: ", props.values);
                // props.onFinish();
                props.handleClose();
              },
            }}
          >
            Change Status
          </Btn>
          <Btn attrBtn={{ color: "primary", onClick: props.handleClose }}>
            Cancel
          </Btn>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default ChangeWorkStatusModal;
